function resolveRuleMessage(fallback, rule) {
  if (rule === void 0 || rule === false) {
    return void 0;
  }
  if (typeof rule === "string") {
    return rule;
  }
  if (typeof rule === "object" && rule !== null && "message" in rule && typeof rule.message === "string") {
    return rule.message;
  }
  return fallback;
}
function ruleValue(rule) {
  if (typeof rule === "object" && rule !== null && "value" in rule) {
    return rule.value;
  }
  return rule;
}
async function validateFieldRules(_valueName, value, rules, values) {
  if (!rules) {
    return void 0;
  }
  if (rules.required) {
    const empty = value === void 0 || value === null || value === "" || Array.isArray(value) && value.length === 0 || value === false;
    if (empty) {
      return resolveRuleMessage("This field is required", rules.required) ?? "This field is required";
    }
  }
  if (typeof value === "number" || typeof value === "string" && value !== "" && !Number.isNaN(Number(value))) {
    const num = typeof value === "number" ? value : Number(value);
    if (rules.min !== void 0 && num < ruleValue(rules.min)) {
      return resolveRuleMessage(`Minimum value is ${ruleValue(rules.min)}`, rules.min);
    }
    if (rules.max !== void 0 && num > ruleValue(rules.max)) {
      return resolveRuleMessage(`Maximum value is ${ruleValue(rules.max)}`, rules.max);
    }
  }
  const str = value == null ? "" : String(value);
  if (rules.minLength !== void 0 && str.length < ruleValue(rules.minLength)) {
    return resolveRuleMessage(`Minimum length is ${ruleValue(rules.minLength)}`, rules.minLength);
  }
  if (rules.maxLength !== void 0 && str.length > ruleValue(rules.maxLength)) {
    return resolveRuleMessage(`Maximum length is ${ruleValue(rules.maxLength)}`, rules.maxLength);
  }
  if (rules.pattern !== void 0) {
    const pattern = ruleValue(rules.pattern);
    if (!pattern.test(str)) {
      const patternRule = rules.pattern;
      const message = typeof patternRule === "object" && "message" in patternRule && typeof patternRule.message === "string" ? patternRule.message : "Invalid format";
      return message;
    }
  }
  if (rules.validate) {
    if (typeof rules.validate === "function") {
      const result = await rules.validate(value, values);
      if (result === true || result === void 0) {
        return void 0;
      }
      if (result === false) {
        return "Invalid value";
      }
      return String(result);
    }
    for (const key of Object.keys(rules.validate)) {
      const fn = rules.validate[key];
      const result = await fn(value, values);
      if (result !== true && result !== void 0) {
        return result === false ? "Invalid value" : String(result);
      }
    }
  }
  return void 0;
}
export async function runRulesResolver(values, context, names) {
  const targetNames = names ?? Object.keys(context.fields);
  const errors = {};
  for (const name of targetNames) {
    const rules = context.fields[name]?.rules;
    const message = await validateFieldRules(name, values[name], rules, values);
    if (message) {
      errors[name] = {
        type: "validation",
        message
      };
    }
  }
  if (Object.keys(errors).length > 0) {
    return {
      values: {},
      errors
    };
  }
  return {
    values,
    errors: {}
  };
}
export function createRulesResolver() {
  return (values, context, options) => runRulesResolver(values, context, options.names);
}